(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/tickets-giftshop/assets/react/pages/gift/components/gift-form/components/cart/cart.js') >= 0) return;  svs.modules.push('/modules/tickets-giftshop/assets/react/pages/gift/components/gift-form/components/cart/cart.js');
"use strict";


const Hr = svs.tickets_giftshop.components.HR;
const List = svs.tickets_giftshop.gift.giftform.cart.components.List;
const Cart = React.forwardRef((props, ref) => React.createElement("div", {
  className: "tg-cart",
  id: "tg-cart",
  ref: ref
}, React.createElement("div", {
  className: "f-body"
}, React.createElement("h2", {
  className: "tg-cart-header h2 u-text-center margin-top-4 margin-bottom-3"
}, "Lotter att ge bort"), React.createElement(Hr, null), React.createElement(List, null))));
svs.tickets_giftshop.gift.giftform.cart.Cart = Cart;

 })(window);